:host {
  @apply w-full h-full overflow-hidden;

  * {
    &::-webkit-scrollbar {
      width: 10px;
      left: -100px;
    }

    &::-webkit-scrollbar-track {
        background-color: var(--vt-color-grey-lighter, #EDEDEC);
        border-top-right-radius: .25rem;
        border-bottom-right-radius: .25rem;
        border-top-left-radius: .25rem;
        border-bottom-left-radius: .25rem;
    }

    &::-webkit-scrollbar-thumb {
        background-color: var(--vt-color-grey-light, #A5A5A2);
        border-radius: 8px;
        border: solid 2px transparent;
        background-clip: content-box;
    }

    scrollbar-color: var(--vt-color-grey-light, #A5A5A2);
    scrollbar-width: thin;
  }
  
  .h-inherit {
    height: inherit;
  }
}
